$(function() {
  $('#select_cp_1').selModal();
  $('#select_cp_2').selModal();
  $('#select_cp_1').change(function() {
    var cp_1 = $('option:selected', this).val();
    $('#' + cp_1).prependTo('ul#cp');
    $('#select_cp_2 option[value="' + cp_1 + '"]').remove();
    $('#select_cp_2').selModal();
    if (window.matchMedia('(min-width: 640px)').matches) {
      // PC表示の時の処理
      $('#cp').css('width','50%');
      $('#cp li').css('width','50%');
    } else {
      // スマホ表示の時の処理
    }
  });
  $('#select_cp_2').change(function() {
    var cp_2 = $('option:selected', this).val();
    $('#' + cp_2).prependTo('ul#cp');
    if (window.matchMedia('(min-width: 640px)').matches) {
      // PC表示の時の処理
      $('#cp').css('width','50%');
      $('#cp li').css('width','50%');
    } else {
        // スマホ表示の時の処理
      
    };
  });
});
